export const COMMON_ERROR = {
  DATA_BLANK: "We are facing some issues at the moment. Please try again later.",
  UNSUPPROTED_BROWSER: "Your web browser does not support storing settings. Please disable private browsing mode.",
  TEJRF0500 : "We are facing some issues at the moment. Please try again later.",
  SCLN0045: "We are facing some issues at the moment. Please try again later.",
  DEFAULT: "We are facing some issues at the moment. Please try again later.",
  //"We are unable to process your request. Please try again later.";
};

export const SORT_ORDER = {
  // UPLOAD_SORTING : "&sort=%2DcreatedDate"
  // UPLOAD_SORT_PARAM :"%2DcreatedDate"
  UPLOAD_SORTING : "&sort=%2DlastModifiedDate",
  UPLOAD_SORT_PARAM :"%2DlastModifiedDate"
}

export const USER_DETAILS = {
  USER_DETAILS : {}
};

export const DEFAULT_USER_DETAILS = {
    totalAllocatedQuota: '',
    totalUsedQuota: '',
    authProviderId: '',
    authProviderToken: '',
    authToken: {
      accessToken: '',
      refreshToken: '',
      expiresIn: ''
    },
    country: '',
    dcGroupCode: '',
    deviceKey: '',
    deviceType: '',
    emailId: '',
    firstName: '',
    idamUnique: '',
    isAdvSearchOn: '',
    isEmailIdVerified: '',
    isForcedMigration: '',
    isMigrationUser: '',
    isMobileNumVerified: '',
    isNewDeviceNotify: '',
    isNewUserNotify: '',
    isStaySignIn: '',
    jToken: '',
    language: '',
    lastName: '',
    lbCookie: '',
    loginId: '',
    mobileNumber: '',
    myBackupObjectKey: '',
    profileIconPhotoPath: '',
    profilePhotoPath: '',
    referralCode: '',
    rootFolderKey: '',
    shardKey: '',
    status: '',
    storageId: '',
    subscriberId: '',
    timeZone: '',
    userId: '',
    authorization: '',
    isMandatoryEmail: '',
    isEntUser:'',
    backupMobileNumber:''
}